module.exports = __webpack_public_path__ + "img/AB.4581f293.jpg";